import ServicesRelated from './ServicesRelated';

export { type ServicesRelatedProps } from './ServicesRelated';
export default ServicesRelated;
